import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import NetworkExtensionEmbed2 from './network-extension-embed2';

@NgModule({
    declarations: [
        NetworkExtensionEmbed2,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        NetworkExtensionEmbed2
    ]
})

export class NetworkExtensionModule2 {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/network-extension2/network-extension.module2.ts